import Gantt from 'frappe-gantt';
import {appState} from 'store/AppStore';
import {ViewMode} from '../CalendarBoxState';
import {Task} from './task';

export class MyGantt extends Gantt {
  setup_tasks(tasks: Task) {
    // @ts-ignore
    super.setup_tasks(tasks);
    // @ts-ignore
    this.tasks = this.tasks.map((t) => {
      t._index = t.index;
      return t;
    });
  }

  setup_gantt_dates() {
    // @ts-ignore
    if (this.view_is(this.options.view_mode)) {
      // @ts-ignore
      this.gantt_start = new Date(appState.calendarBoxState?.begins);
      // @ts-ignore
      this.gantt_end = new Date(appState.calendarBoxState?.ends);
    }
  }

  update_view_scale(view_mode: unknown) {
    function changeColumnWidth(
      openSbAnWindowRange: number,
      openSbAndNotWindowRange: number,
      notOpenSbAndWindowRange: number,
      notOpenSbAndNotWindowRange: number
    ) {
      const windowRange = undefined;
      const openSB = undefined;
      if (openSB) {
        return windowRange ? openSbAnWindowRange : openSbAndNotWindowRange;
      } else {
        return windowRange ? notOpenSbAndWindowRange : notOpenSbAndNotWindowRange;
      }
    }

    function result() {
      const days = appState.calendarBoxState?.daysInMonth ?? 30;
      switch (days) {
        case 28:
          return changeColumnWidth(65, 42, 72.8, 49.8);
        case 29:
          return changeColumnWidth(63.5, 40.5, 71, 48);
        case 30:
          return changeColumnWidth(60, 39.3, 67.2, 46.5);
        case 31:
          return changeColumnWidth(58, 38, 58, 45);
        default:
          return 55;
      }
    }

    // @ts-ignore
    super.update_view_scale(view_mode);
    if (view_mode === ViewMode.Day) {
      // @ts-ignore
      this.options.step = 24;
      // @ts-ignore
      this.options.column_width = result();
    } else if (view_mode === ViewMode.Month) {
      // @ts-ignore
      this.options.step = 24 * 30;
      // @ts-ignore
      this.options.column_width = 114.5;
    }
  }

  bind_bar_events() {
    console.debug('events are disabled');
  }
}
